import { useConnect } from '@lore/query-connect';
import { event_networkId } from '../../../../utils/query-helpers';

export default function useEducatorEventEvaluationsCompleted(network, timestamp) {
  return useConnect('evaluationEventEducator.find', {
    where: {
      eager: {
        $where: {
          ...event_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          },
          completed: true
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
